export default "__VITE_ASSET__DQGaV9V5__"